import { ApiProperty, ApiPropertyOptional } from "@nestjs/swagger";
import {
  IsBoolean,
  IsDate,
  IsEnum,
  IsNotEmpty,
  IsNumber,
  IsOptional,
  IsString,
  MaxLength,
  IsArray,
  ValidateNested
} from "class-validator";
import { Type, Transform } from "class-transformer";
import { QualityTypeEnum } from "@gtpl/shared-models/common-models";

export class QaqcProductCountsDto {

  @ApiPropertyOptional()
  @IsOptional()
  @IsNumber()
  id: number;

  @ApiPropertyOptional()
  @Type(() => Date)
  @IsDate()
  @IsOptional()
  createdAt: Date;

  @ApiPropertyOptional()
  @IsString()
  @IsOptional()
  @MaxLength(50)
  createdUser: string;

  @ApiPropertyOptional()
  @Type(() => Date)
  @IsDate()
  @IsOptional()
  updatedAt: Date;

  @ApiPropertyOptional()
  @IsString()
  @IsOptional()
  @MaxLength(50)
  updatedUser: string;

  @ApiPropertyOptional()
  @IsOptional()
  versionFlag: number;

  @ApiProperty()
  @Type(() => Date)
  @IsDate()
  testDate: Date;

  @ApiPropertyOptional()
  @IsString()
  @IsOptional()
  @MaxLength(255)
  processType: string;

  @ApiPropertyOptional()
  @IsString()
  @IsOptional()
  @MaxLength(255)
  lotNumber: string;

  @ApiPropertyOptional()
  @IsString()
  @IsOptional()
  @MaxLength(100)
  operation: string;

  @ApiPropertyOptional()
  
  @IsOptional()
  
  product: Number;

  @ApiPropertyOptional()
  @IsEnum(QualityTypeEnum)
  @IsOptional()
  quality: QualityTypeEnum;

  @ApiPropertyOptional()
  
  
@IsOptional()
  quantity: any;

  @ApiPropertyOptional()
  @IsString()
  @IsOptional()
  @MaxLength(50)
  productType: string;

  @ApiPropertyOptional()
  @IsNumber()
  @IsOptional()
  weightInGms: number;

  @ApiPropertyOptional()
  @IsNumber()
  @IsOptional()
  count: number;

  @ApiPropertyOptional()
  @Transform(({ value }) => value === 1 || value === true)
  @IsBoolean()
  @IsOptional()
  isQAQCApproved: boolean;

  @ApiPropertyOptional()
  @IsBoolean()
  @IsOptional()
  is_qaqc_one_done: boolean;

  @ApiPropertyOptional()
  @IsBoolean()
  @IsOptional()
  is_qaqc_two_done: boolean;

  @ApiPropertyOptional()
  @IsBoolean()
  @IsOptional()
  is_qaqc_three_done: boolean;
}

export class ProductCountItemDto {

  @ApiProperty()
  @IsString()
  @MaxLength(255)
  processType: string;

  @ApiProperty()
  @IsNumber()
  weightInGms: number;

  @ApiProperty()
  @IsNumber()
  count: number;
}

export class CreateQaqcProductCountsDto extends QaqcProductCountsDto {

  @ApiProperty({ type: [ProductCountItemDto] })
  @IsOptional()
  @IsArray()
  @ValidateNested({ each: true })
  @Type(() => ProductCountItemDto)
  items: ProductCountItemDto[];
}

export class UpdateQaqcProductCountsDto extends QaqcProductCountsDto {

  @ApiProperty()
  @IsNotEmpty()
  @IsNumber()
  id: number;
}

export class UpdateQaqcProductCountsArrayDto {

  @ApiProperty({ type: [UpdateQaqcProductCountsDto] })
  @IsArray()
  @ValidateNested({ each: true })
  @Type(() => UpdateQaqcProductCountsDto)
  data: UpdateQaqcProductCountsDto[];
}